var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoCaminoNiveles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 276,
    viewBox: "0 0 1280 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1062_2806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1283,
    height: 451
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1283 451H0V3.05176e-05H1283V451Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1062_2806)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-168.508 835H1345L1345 153.5C1345 153.5 1138.22 47.5319 919 213C858.629 258.561 728.768 279.462 611.167 282.781C482.973 286.398 394.315 253.503 280.124 236.564C127.941 214 -104.469 216.923 -160.075 302.71C-240.173 426.312 -168.508 834.99 -168.508 834.99V835Z",
    fill: "#00733A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.2847 940.5H1288.64V161.39C1288.64 161.39 1082.24 111.79 893.958 283.32C842.106 330.55 759.368 364.61 658.363 368.05C548.26 371.8 472.112 337.7 374.037 320.14C243.329 296.75 43.7168 299.78 -4.0421 388.71C-72.8366 516.84 -11.2847 940.5 -11.2847 940.5Z",
    fill: "#15A054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-148.462 475C-133.328 457.099 -116.614 439.837 -95.5765 426.608C-64.2753 406.83 -27.0821 393.911 10.7169 385.814C188.724 349.054 364.236 414.718 539.155 435.174C643.631 448.812 750.578 443.561 848.105 407.12C888.458 392.683 925.318 371.448 955.503 344.681C985.83 318.184 1009.99 287.314 1038.94 259.868C1101.21 198.937 1175.28 175.185 1269.7 173.767C1304.6 173.019 1339.5 174.836 1374.29 177.112C1339.5 174.606 1304.62 172.569 1269.68 173.079C1174.31 173.887 1100.39 197.409 1037.18 258.56C1008.1 285.916 983.751 316.596 953.436 343.014C923.441 369.521 886.949 390.497 846.893 404.764C750.079 440.855 643.298 445.867 539.618 432.509C364.629 412.112 188.344 346.797 10.3487 384.566C-27.4978 392.943 -64.7148 406.141 -95.9329 426.199C-116.876 439.577 -133.482 456.989 -148.45 475H-148.462Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoCaminoNiveles);
export default __webpack_public_path__ + "static/media/fondo_camino_niveles.ebe5471f0dce922f46c91b68912d47fe.svg";
export { ForwardRef as ReactComponent };